import React, { useState } from "react"
import { VictoryPie, VictoryTooltip } from "victory"
import ImageGallery from "react-image-gallery"

export const ODSComponent = (props) => {
  if (props.type === "checkbox") {
    return <PieChart {...props} />
  } else if (props.type === "select") {
    return <PieChart {...props} />
  } else if (props.type === "radio") {
    return <PieChart {...props} />
  } else if (props.type === "text") {
    return <PieChart {...props} />
  } else if (props.type === "file") {
    return <Gallery {...props} />
  } else if (props.type === "url") {
    return <LinkPreviewGallery {...props} />
  } else if (props.type === "number") {
    return <NumberCard {...props} />
  } else {
    return <div style={{ fontSize: 18 }}>{props.type}</div>
  }
}

// else if (props.type === 'url') {
//     return <LinkPreviewGallery {...props} />
// }

const images = [
  {
    original: "https://picsum.photos/id/1018/1000/600/",
    thumbnail: "https://picsum.photos/id/1018/250/150/",
  },
  {
    original: "https://picsum.photos/id/1015/1000/600/",
    thumbnail: "https://picsum.photos/id/1015/250/150/",
  },
  {
    original: "https://picsum.photos/id/1019/1000/600/",
    thumbnail: "https://picsum.photos/id/1019/250/150/",
  },
]

function maxMinAvg(arr) {
  var max = arr[0]
  var min = arr[0]
  var sum = arr[0]
  for (var i = 1; i < arr.length; i++) {
    if (arr[i] > max) {
      max = arr[i]
    }
    if (arr[i] < min) {
      min = arr[i]
    }
    sum = sum + arr[i]
  }
  var avg = sum / arr.length
  return [sum || 0, max || 0, min || 0, avg || 0]
}

export const NumberCard = ({ dw }) => {
  const values = [...new Set(dw.map((item) => `${item.Resposta}`.split("|")).flat())]
    .map((item) => Number(item))
    .filter((item) => !isNaN(item))

  const [sum, max, min, avg] = maxMinAvg(values)
  return (
    <div className="card-Indicator-Container">
      <div className="card-Indicator">
        <span className="title-indicator">Soma</span>
        {sum.toFixed(2)}
      </div>
      <div className="card-Indicator">
        <span className="title-indicator">Média</span>
        {avg.toFixed(2)}
      </div>
      <div className="card-Indicator">
        <span className="title-indicator">Máximo</span>
        {max.toFixed(2)}
      </div>
      <div className="card-Indicator">
        <span className="title-indicator">Mínimo</span>
        {min.toFixed(2)}
      </div>
    </div>
  )
}

export const PieChart = ({ dw }) => {
  const values = [...new Set(dw.map((item) => `${item.Resposta}`.split("|")).flat())]
  const sumData = values
    .map((key) => dw.filter((item) => `${item.Resposta}`.split("|").includes(key)).length)
    .reduce((a, b) => a + b, 0)

  return (
    <VictoryPie
      data={values.map((x) => ({
        x,
        y: dw.filter((item) => `${item.Resposta}`.split("|").includes(x)).length,
      }))}
      colorScale={["#D8AAB1", "#9F8BAA", "#D5C7A9", "#EAE1D6", "#A4ABC5"]}
      labelComponent={<VictoryTooltip style={{ fontSize: 12 }} />}
      height={250}
      labels={({ datum }) => {
        return `${datum.xName}-${((datum.y / sumData) * 100).toFixed(2)}%`
      }}
    />
  )
}

const ImageOrVideo = ({ src, controls, height, className, onClick, items, alt }) => {
  const [error, setError] = useState()

  if (error) {
    return (
      <video
        autoPlay={false}
        id="videoId"
        className={className ? className : ""}
        height={height}
        controls={controls}
      />
    )
  }

  return (
    <img
      height={height}
      className={className ? className : "image-gallery-image"}
      onError={() => setError(true)}
      src={src}
      alt={alt ? alt : ""}
      srcset=""
      width=""
      sizes="(max-width: 768px) 120px,
      (max-width: 1023px) 193px,
      278px"
      title=""
      loading="eager"
      onClick={onClick}
    />
  )
}

export const Gallery = ({ dw, onClick }) => {
  const values = dw?.map((item) => {
    return {
      ...item,
      Resposta: `${item.Resposta}`.split("|"),
    }
  })

  const format = Array.isArray(values) && values.map((item) => ({
    original: item.Resposta[0],
    thumbnail: item.Resposta[0],
    detalhes: item.Atendimento,
    originalAlt: item.Atendimento,
  })) || []

  return (
    <ImageGallery
      lazyLoad={true}
      items={format.filter(
        (v, i, a) =>
          a.findIndex((v2) => ["detalhes", "original"].every((k) => v2[k] === v[k])) === i,
      )}
      onErrorImageURL="https://raw.githubusercontent.com/xiaolin/react-image-gallery/master/static/3.jpg"
      onClick={onClick}
      renderItem={(item) => (
        <ImageOrVideo
          controls={true}
          height={400}
          src={item.original}
          items={values.flatMap((item) => ({
            url: item.Resposta[0],
          }))}
          alt={item.originalAlt}
        />
      )}
      renderThumbInner={(e) => (
        <ImageOrVideo
          controls={false}
          height={100}
          className="image-gallery-thumbnail-image"
          src={e.thumbnail}
          fallbackImage={"https://cdn-icons-png.flaticon.com/512/4404/4404094.png"}
        />
      )}
    />
  )
}

// export const LinkPreviewGallery = ({ dw }) => {
//     const values = [...new Set(dw.map(item => `${item.Resposta}`.split("|")).flat())].filter(item => `${item}`.includes('http'))
//     console.log({ links: values })
//     return <div style={{ display: "flex", flexWrap: 'wrap' }}>
//         {values.map(url => <LinkPreview url={url} width='300px' />)}
//     </div>
// }

// const LinkPreview = ({ url }) => {
//     const [state, setState] = useState();

//     useEffect(() => {
//         getLinkPreview(url).then((data) =>
//             setState(data)
//         );
//     }, [url])

//     console.log(state);

//     return <></>
// }
